<template>
  <b-form-checkbox :id="fieldId"
                   :checked="value"
                   :value="true"
                   :unchecked-value="false"
                   :disabled="disabled"
                   @change="changeHandler"
                   @input="inputHandler">
    {{ label }}
  </b-form-checkbox>
</template>

<script>
import formFieldComponentMixin from '../../mixins/formFieldComponentMixin'

export default {
  name: 'CheckboxInput',
  mixins: [formFieldComponentMixin],
}
</script>
